import React from 'react'
import PgaCoachProgramsPage from '@layouts/pga-coach-search/programs-page'
import { getPgaCoachProgramsPageInitialProps } from '@lib/pga-coach/get-programs-page-initial-props'

function GolfLessonsSeoPage(props) {
  return <PgaCoachProgramsPage {...props} />
}

GolfLessonsSeoPage.getInitialProps = getPgaCoachProgramsPageInitialProps

export default GolfLessonsSeoPage
